// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

class CompaniesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    const { modalOpen } = this.state
    return (
      <div id="companies-page">
        <Header
          title="Companies"
          actions={[
            {
              children: 'Create New Company',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              name: 'Name',
              key: 'name',
              link: `/companies/:_id`,
              sortable: true,
            },
            {
              name: 'Products',
              key: 'products',
            },
            {
              name: 'Account Manager',
              key: 'account_manager',
            },
          ]}
          entities="companies"
          fields={['name', 'products', 'account_manager']}
          filters={[]}
          searchable={true}
          sort_dir={1}
          sort_key={'name'}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="companies"
            title="Enter a name for the new Company"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default CompaniesPage
